import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const reportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReports: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `report/?${qs}`;
      },
      providesTags: ['Report'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetReportsQuery
} = reportApi;
